import React, { useState } from 'react';
import { Grid, Collapse, Box, Button, Typography, Alert } from '@mui/material';
import {
    Input,
    Select,
    InformationAlert,
} from "../../Common";
import Enums from '../../../enums';
import { TranslateW } from "../../../Utils/Languages/Translate";

const RepairNotes = ({
    formState,
    setGlobalState,
    dropdownOptions,
    requiredFieldsMissing,
}) => {
    const [warning, setWarning] = useState(false);
    const renderServiceActionField = formState.workItemTypeId === Enums.SE.WorkItemType.ServiceOrLeakRepair;
    const showRepairOutcome = renderServiceActionField && formState.initialLeakInspection?.wasLeakFound === true;
    const repairOutcomeLabelSx = {
        color: '#000000',
        fontSize: '12px',
        fontWeight: 700,
        letterSpacing: '0.04em',
        lineHeight: 1.2,
        mb: 1.5,
        textTransform: 'uppercase',
    };
    const getRepairOutcomeButtonSx = (isSelected) => ({
        flex: 1,
        minHeight: '38px',
        borderRadius: '4px',
        border: `1px solid ${isSelected ? '#0E97B7' : '#D0D5DD'}`,
        backgroundColor: '#FFFFFF',
        color: isSelected ? '#0E97B7' : '#98A2B3',
        fontSize: '12px',
        fontWeight: 500,
        lineHeight: 1.2,
        textTransform: 'none',
        justifyContent: 'center',
        px: 1.5,
        '&:hover': {
            borderColor: '#0E97B7',
            backgroundColor: '#FFFFFF',
        },
    });

    return (
        <Grid container spacing={4}>
            {renderServiceActionField && (
                <Grid item xs={12} md={6}>
                    <Select
                        required
                        label={TranslateW("generalService.service-action")}
                        value={formState.serviceActionId}
                        onChange={e => setGlobalState("serviceActionId", e.target.value)}
                        options={dropdownOptions.serviceActions}
                        error={requiredFieldsMissing.serviceActionId}
                        disabled={!formState.workItemTypeId}
                    />
                </Grid>
            )}
            <Grid item xs={12} md={12}>
                <Input
                    fullWidth
                    multiLine
                    label={TranslateW('generalService.parts-required') }
                    value={formState.partsRequired}
                    onChange={e => setGlobalState("partsRequired", e.target.value)}
                />
            </Grid>
            <Grid item xs={12} md={12}>
                <Input
                    fullWidth
                    multiLine
                    required
                    label={TranslateW("leakRepair.repair-notes") }
                    value={formState.repairNotes}
                    onChange={e => setGlobalState("repairNotes", e.target.value)}
                    onFocus={() => setWarning(true)}
                    error={requiredFieldsMissing.repairNotes}
                />
            </Grid>
            <Grid item xs={12} md={12} lg={12} sx={{ display: warning ? 'block' : 'none' }}>
                <Collapse in={warning}>
                    <Grid item xs={12} md={12} lg={12}>
                        <InformationAlert
                            title={TranslateW('Information')}
                            message={TranslateW("ExactLeakDescription") }
                            onClose={() => setWarning(false)}
                        />
                    </Grid>
                </Collapse>
            </Grid>
            {showRepairOutcome && (
                <Grid item xs={12} md={12} lg={6}>
                    <Typography sx={repairOutcomeLabelSx}>
                        {TranslateW("repairOutcome.label")} <span style={{ color: '#F04438' }}>*</span>
                    </Typography>
                    <Box display="flex" gap={1.5}>
                        {dropdownOptions.repairOutcomeTypes?.map((option) => {
                            const isSelected = formState.repairOutcomeTypeId === option.id;
                            return (
                                <Button
                                    key={option.id}
                                    variant="outlined"
                                    onClick={() => setGlobalState("repairOutcomeTypeId", option.id)}
                                    sx={getRepairOutcomeButtonSx(isSelected)}
                                >
                                    {option.name}
                                </Button>
                            );
                        })}
                    </Box>
                    {requiredFieldsMissing.repairOutcomeTypeId && (
                        <Typography sx={{ color: '#D32F2F', fontSize: '12px', mt: 1 }}>
                            This field is required
                        </Typography>
                    )}
                </Grid>
            )}
            {showRepairOutcome && formState.repairOutcomeTypeId && (
                <Grid item xs={12} md={12} lg={12}>
                    <Alert severity="info">
                        {TranslateW(`repairOutcome.Guidance.${formState.repairOutcomeTypeId}`)}
                    </Alert>
                </Grid>
            )}
        </Grid>
    );
};

export default RepairNotes;
